import {
  MUTATION_ADD_SIDE,
  MUTATION_DELETE_SIDE,
  MUTATION_ORDER_DATA,
  MUTATION_SET_COMPOSITION,
  MUTATION_UPDATE_SIDE_CONTENT,
  MUTATION_UPDATE_SIDE_PRINTSTYLE
} from './mutation-types';
import Vue from 'vue';

export default {
  [MUTATION_ORDER_DATA]: (state, orderData) => {
    state.orderData = orderData;
  },
  [MUTATION_SET_COMPOSITION]: (state, composition) => {
    state.composition = composition;
  },
  [MUTATION_UPDATE_SIDE_CONTENT]: (state, { side, content }) => {
    state.composition.printPlates[side].content = content;
  },
  [MUTATION_UPDATE_SIDE_PRINTSTYLE]: (state, { side, printStyle }) => {
    state.composition.printPlates[side].printStyle = printStyle;
  },
  [MUTATION_DELETE_SIDE]: (state, side) => {
    Vue.delete(state.composition.printPlates, side);
  },
  [MUTATION_ADD_SIDE]: (state, { side, printPlate }) => {
    Vue.set(state.composition.printPlates, side, printPlate);
  }
};
